import React from "react"
import v from "voca"
import { Link } from "gatsby"

export default props => {
  const fm = props.node.frontmatter
  const fmTechnologies = fm.technologies && fm.technologies.join(", ")

  return (
    <article
      className={`post-card ${props.postClass} ${
        props.node.frontmatter.thumbnail ? `with-image` : `no-image`
      }`}
      style={
        props.node.frontmatter.thumbnail && {
          backgroundImage: `url(${
            props.node.frontmatter.thumbnail.childImageSharp.fluid.src
          })`,
        }
      }
    >
      <Link to={props.node.fields.slug} className="post-card-link">
        <div className="post-card-content" />
        <div className="sntx-post-card-content-right">
          <p className="sntx-post-card-content-right-title">
            {v.titleCase(fm.title)}
          </p>
          <p className="sntx-post-card-content-right-technologies">
            {fmTechnologies}
          </p>
          <p className="sntx-post-card-content-right-description">
            {fm.description}
          </p>
        </div>
      </Link>
    </article>
  )
}
